import {
  API_URL,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from '../../lib'
import {doBATCH_PARTICIPANT_TAG_LIST_ADD, doREQUEST_COMPLETE, doREQUEST_ERROR} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_TAG_ADD = 'REQUEST_PARTICIPANT_TAG_ADD'
export const doREQUEST_PARTICIPANT_TAG_ADD = createDoRequestAction(REQUEST_PARTICIPANT_TAG_ADD)

export const requestParticipantTagAddActionCreators = {
  doREQUEST_PARTICIPANT_TAG_ADD,
}

export function* requestParticipantTagAdd({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestParticipantTagAdd')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        batchId: v.string().uuid().exist(),
        participantId: v.string().uuid().exist(),
        tagIds: v.array().items(v.string().uuid().exist()).exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_TAG_ADD,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {participantId, batchId, tagIds} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'POST',
    url: `${API_URL}/v1/web/participant-tag-add`,
    accessToken,
    data: {
      participantId,
      tagIds,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_TAG_ADD,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/participant-tag-add',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doBATCH_PARTICIPANT_TAG_LIST_ADD({
      batchId,
      participantId,
      tags: result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_TAG_ADD,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* participantTagAddSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_TAG_ADD, requestParticipantTagAdd)
}
